<div class="main-container">
  <app-desktop-introduction
    [slides]="slides"
    [currentSlide]="currentSlide"
    [isFirstStep]="isFirstStep"
    [isTwoButtons]="isTwoButtons"
    [isFinalStep]="isFinalStep"
    (previous)="onPreviousClick()"
    (next)="onNextClick()"
    (skip)="onSkip()"
    class="desktop-view"
  ></app-desktop-introduction>
  <app-mobile-introduction
    [slides]="slides"
    [currentSlide]="currentSlide"
    [isFirstStep]="isFirstStep"
    [isTwoButtons]="isTwoButtons"
    [isFinalStep]="isFinalStep"
    (previous)="onPreviousClick()"
    (next)="onNextClick()"
    (skip)="onSkip()"
    class="mobile-view"
  ></app-mobile-introduction>
</div>
